import { Fields, FormOption } from 'common/form';
import { SelectTalentPoolFormData } from 'modules/candidate-profile/forms/schema/selectTalentPoolSchema';

type GetSelectTalentPoolFieldsProps = {
  onSearchFilter: (query: string) => Promise<FormOption[]>;
};

export const getSelectTalentPoolFields = ({
  onSearchFilter
}: GetSelectTalentPoolFieldsProps): Fields<SelectTalentPoolFormData> => ({
  talentPoolId: {
    type: 'server-dropdown',
    label: 'Your talent lists',
    onSearchFilter,
    searchPlaceholder: 'Search talent lists...',
    buttonText: 'Select a talent list',
    popperSx: {
      zIndex: 1401
    }
  }
});
